import * as React from "react";
import Typography from "@mui/material/Typography";
import {
  AppBar,
  Toolbar,
  IconButton,
  Button,
  CircularProgress,
  Container,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Grid,
  ListItemSecondaryAction,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Tooltip,
  Menu,
  MenuItem,
  Box,
  Alert,
  AlertColor,
  Avatar,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { styled } from "@mui/material/styles";
import autobind from "autobind-decorator";
import { RouterStore } from "mobx-react-router";
import AccountService, { ClinicMetadata } from "../../service/AccountService";
import { inject, observer } from "mobx-react";
import PictureIcon from "@mui/icons-material/PictureInPicture";
import HelpIcon from "@mui/icons-material/Help";
import {
  ContentCopyOutlined,
  EditOutlined,
  PlayCircleFilledWhiteOutlined,
  MailOutlineOutlined,
  DeleteOutlineOutlined,
} from "@mui/icons-material";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import NewFileDialog, { NewFileDialogState } from "./NewFileDialog";
import LogoutButton from "../common/LogoutButton";
import FileService, { FileMetadata } from "../../service/FileService";
import { observable } from "mobx";
import SideDrawer, { SideDrawerState } from "./SideDrawer";
import NewClinicDialog, { NewClinicDialogState } from "./NewClinicDialog";
import { getPlatformType } from "../../Config";
import UpgradePlanDialog, {
  UpgradeDialogState,
} from "../subscription/UpgradePlanDialog";
import EditIcon from "@mui/icons-material/Edit";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import GroupIcon from "@mui/icons-material/Group";
import LayersIcon from "@mui/icons-material/Layers";
import { withStyles } from "@mui/styles";
import { Input } from "rsuite";
import PhoneInput from "react-phone-input-2";
import { notification } from "antd";
import firebase from "firebase/compat/app";
import ReactPlayer from "react-player/lazy";
import RunningWithErrorsIcon from "@mui/icons-material/RunningWithErrors";
import UpdateIcon from "@mui/icons-material/Update";
import moment from "moment";

const WorkflowsContainer = withStyles({
  root: {
    marginLeft: "0px !important",
    marginTop: "36px !important",
    paddingLeft: "60px !important",
    paddingBottom: "1.5rem !important",
  },
  "@media screen and (max-width: 590px)": {
    root: {
      paddingLeft: "16px",
      marginTop: "16px",
    },
  },
})(Container);

const TitlePaper = withStyles({
  root: {
    display: "flex",
    alignItems: "center",
    fontSize: "larger",
    padding: "20px 15px !important",
    columnGap: "8px !important",
    boxShadow:
      "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%) !important",
  },
  "@media screen and (max-width: 590px)": {
    root: {
      fontSize: "15px",
      padding: "20px 15px",
      fontWeight: "500",
    },
  },
})(Paper);

const NavButton = withStyles({
  colorInherit: {
    color: "#FFF",
  },
})(Button);

const MenuNavButton = withStyles({
  colorInherit: {
    color: "#000",
  },
})(Button);

const MobileHideDiv = styled("div")({
  "@media screen and (max-width: 720px)": {
    display: "none",
  },
});
const BrowserHideDiv = styled("div")({
  "@media screen and (min-width: 720px)": {
    display: "none",
  },
});

const MenuDiv = styled("div")({
  display: "flex",
  alignItems: "center",
});

export const CustomTooltip = withStyles({
  tooltip: {
    maxWidth: "450px",
    fontSize: "1rem",
    backgroundColor: "#007bff",
    padding: "0.5rem",
  },
  arrow: {
    color: "#007bff",
  },
})(Tooltip);

type FileListPageProps = {
  routing?: RouterStore;
  account?: AccountService;
  files?: FileService;
};

type ChartListStatus = "LOADING" | "NORMAL";

@inject("account")
@inject("routing")
@inject("files")
@observer
export default class FileListPage extends React.Component<FileListPageProps> {
  _fileDialogState = new NewFileDialogState();
  _clinicDialogState = new NewClinicDialogState();
  _upgradeDialogState = new UpgradeDialogState();

  _sideDrawerState = new SideDrawerState();

  @observable
  private _status: ChartListStatus = "NORMAL";

  @observable
  private _deletingFile: string = null;

  @observable
  private _selectedFile: FileMetadata = null;

  @observable
  private anchorElMain = null;

  @observable
  private _currentOpenFile: FileMetadata = null;

  @observable
  private anchorEl = null;

  @observable
  private _deleteDialog: boolean = false;

  @observable
  private _fileToDelete: FileMetadata = null;

  @observable
  private _editFile: FileMetadata = null;

  @observable
  private _isFileNameEdit: boolean = false;

  @observable
  private _selectedFileName: string = "";

  @observable
  private _tutorialVideoOpen = false;

  @observable
  openFlowchartsTooltip = false;

  @observable
  openChatTooltip = false;

  @observable
  phoneNumber = "";

  @observable
  private _showSnackbar: boolean = false;

  @observable
  private _snackbarMessage: string = "";

  @observable
  private _snackbarType: AlertColor = "success";

  @autobind
  addFile() {
    if (this.props.account.currentClinic == "") {
      this.addClinic();
      return;
    }
    if (this.props.account.IsPlanExpired()[1].limit) {
      this._upgradeDialogState.open = true;
    } else {
      this._fileDialogState.fileName = "";
      this._fileDialogState.open = true;
    }
  }

  @autobind
  addClinic() {
    if (this.props.account.IsPlanExpired()[0].limit) {
      this._upgradeDialogState.open = true;
    } else {
      this._clinicDialogState.clinicName = "";
      this._clinicDialogState.open = true;
    }
  }

  handleMoreClick(event: React.MouseEvent<HTMLButtonElement>) {
    this.anchorElMain = event.currentTarget;
  }

  @autobind
  handleMoreClose() {
    this.anchorElMain = null;
  }

  @autobind
  async handleFileDuplicate(name: string, fileId: string) {
    var { files } = this.props.files;

    var currentFiles = files.filter(
      (file) => file.clinic == this.props.account.currentClinic
    );
    const filesNames = currentFiles.map((file) => file?.name);
    await this.props.files.createDuplicateFile(name, fileId, filesNames);
    this.handleFileMoreClose();
  }

  handleFileMoreClick(
    event: React.MouseEvent<HTMLButtonElement>,
    currentOpenFile: FileMetadata
  ) {
    this.anchorEl = event.currentTarget;
    this._currentOpenFile = currentOpenFile;
  }

  @autobind
  handleFileMoreClose() {
    this.anchorEl = null;
  }

  @autobind
  async saveFileNameChange() {
    let result = await this.props.files.updateFileName(
      this._editFile.fileId,
      this._selectedFileName
    );
    if (result === "SUCCESS") {
      this._showSnackbar = true;
      this._snackbarMessage = "Flow name updated successfully";
      this._snackbarType = "success";
      this._isFileNameEdit = false;
      await this.props.files.refreshFileList();
    } else {
      this._snackbarMessage = result.toString();
    }
  }

  handleFileNameEdit(file: any) {
    this._isFileNameEdit = true;
    this._editFile = file;

    this.handleFileMoreClose();
  }

  handleDeleteFile(file: any) {
    this._fileToDelete = file;
    this.handleDeleteDialogOpen();
    this.handleFileMoreClose();
  }

  async deleteFile(fileId: string) {
    this._deletingFile = fileId;
    var { files } = this.props;

    await files.deleteFile(fileId);

    this._deletingFile = null;
  }

  getSurveyLink(fileId: string) {
    var { account } = this.props;
    return `/questionnaire/${account.user.uid}/${account.currentClinic}/${fileId}`;
  }

  gotoFile(fileId: string) {
    var { routing } = this.props;

    if (getPlatformType() == "BROWSER") {
      routing.push(`/editor/${fileId}`);
    } else {
      routing.push(this.getSurveyLink(fileId));
    }
  }

  gotoQuestionnaire(fileId: string) {
    this.handleFileMoreClose();
    var { routing } = this.props;
    routing.push(this.getSurveyLink(fileId));
  }

  @autobind
  gotoNarratives(fileId: string) {
    var { routing } = this.props;
    routing.push(`/narratives/${fileId}`);
  }

  @autobind
  gotoProfile() {
    var { routing } = this.props;
    routing.push(`/profile`);
  }

  @autobind
  gotoContact() {
    var { routing } = this.props;
    routing.push(`/contacts`);
  }

  @autobind
  gotoTemplate() {
    var { routing } = this.props;
    routing.push(`/templates`);
  }

  @autobind
  gotoPlan() {
    var { routing } = this.props;
    routing.push(`/plan`);
  }

  @autobind
  async startFreeTrialHandler() {
    var { routing, account } = this.props;

    const result = await account.startFreeTrial(account.user.uid);
    if (result === "SUCCESS") {
      this._showSnackbar = true;
      this._snackbarMessage = "Free trial started successfully";
      this._snackbarType = "success";
      routing.replace("/");
    } else {
      this._showSnackbar = true;
      this._snackbarMessage = "Something went wrong";
      this._snackbarType = "error";
    }
  }

  async handleDeleteDialogClose(response?: boolean) {
    if (response) {
      await this.deleteFile(this._fileToDelete.fileId);
    }
    this._deleteDialog = false;
  }

  @autobind
  handleDeleteDialogOpen() {
    this._deleteDialog = true;
  }

  async componentDidMount() {
    if (getPlatformType() == "MOBILE" && localStorage.getItem("Qid")) {
      this.props.routing.push(this.getSurveyLink(localStorage.getItem("Qid")));
    }

    var { files } = this.props;

    this._status = "LOADING";
    await files.refreshFileList();

    this._status = "NORMAL";

    const userId = this.props.account.user.uid;
    const userData = await firebase
      .firestore()
      .collection("userx")
      .doc(userId)
      .get();
    const user = await userData.data();
    this.phoneNumber = user?.phoneNumber;
  }

  @autobind
  openTutorial() {
    this._tutorialVideoOpen = true;
  }

  renderNavBar() {
    var clinicName = this.props.account.getCurrentClinicName();
    var pred = "";
    if (clinicName != "") {
      pred = `${clinicName}`;
    }

    const userData = this.props.account.userData;
    const userType = this.props.account.userData.userType;
    const startDateOfFreeTrial = moment(userData?.freeTrialStartDate);
    const endDateOf7DayPeriod = startDateOfFreeTrial.clone().add(7, "days");
    const daysLeftInTrial = endDateOf7DayPeriod.diff(moment(), "days");
    return (
      <AppBar position="static">
        <SideDrawer
          state={this._sideDrawerState}
          onAddClinicClicked={this.addClinic}
        />

        <Toolbar variant="dense" style={{ display: "flex" }}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={() => this._sideDrawerState.setOpen(true)}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" style={{ flex: "1", color: "inherit" }}>
            {pred}
          </Typography>
          <BrowserHideDiv>
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={(e) => this.handleMoreClick(e)}
            >
              <MoreVertIcon style={{ color: "#FFF" }} />
            </IconButton>
            <Menu
              id="main-menu"
              anchorEl={this.anchorElMain}
              keepMounted
              open={Boolean(this.anchorElMain)}
              onClose={this.handleMoreClose}
            >
              <MenuItem onClick={this.handleMoreClose}>
                <MenuNavButton
                  aria-label="menu"
                  onClick={this.gotoProfile}
                  color="inherit"
                >
                  <AccountBoxIcon style={{ marginRight: "10px" }} />
                  PROFILE
                </MenuNavButton>
              </MenuItem>
              <MenuItem onClick={this.handleMoreClose}>
                <MenuNavButton
                  aria-label="menu"
                  onClick={this.gotoContact}
                  color="inherit"
                >
                  <GroupIcon style={{ marginRight: "10px" }} />
                  CONTACT
                </MenuNavButton>
              </MenuItem>
              <MenuItem onClick={this.handleMoreClose}>
                <MenuNavButton
                  aria-label="menu"
                  onClick={this.gotoTemplate}
                  color="inherit"
                >
                  <LayersIcon style={{ marginRight: "10px" }} />
                  TEMPLATE
                </MenuNavButton>
              </MenuItem>
              {/* <MenuItem onClick={this.handleMoreClose} >
                                <MenuNavButton  aria-label="menu" onClick={this.gotoNarratives}>
                                    <MailIcon style={{marginRight:'10px'}}/> RESPONSES 
                                </MenuNavButton>
                            </MenuItem> */}

              <MenuItem onClick={this.handleMoreClose}>
                <MenuNavButton
                  aria-label="menu"
                  onClick={this.openTutorial}
                  color="inherit"
                >
                  <HelpIcon style={{ marginRight: "10px" }} /> TUTORIAL VIDEO
                </MenuNavButton>
              </MenuItem>
              <MenuItem onClick={this.handleMoreClose}>
                <LogoutButton type="MOBILE" />
              </MenuItem>
            </Menu>
          </BrowserHideDiv>

          <MobileHideDiv>
            {userType == "FREE_USER" &&
              userData?.freeTrialStartDate &&
              daysLeftInTrial > 0 && (
                <NavButton
                  aria-label="menu"
                  onClick={this.gotoPlan}
                  color="inherit"
                  style={{
                    color: "#fffd02",
                  }}
                >
                  <RunningWithErrorsIcon style={{ marginRight: "10px" }} />
                  {`Trial: ${daysLeftInTrial} days left. Upgrade now!`}
                </NavButton>
              )}
            {userType == "FREE_USER" && !userData?.freeTrialStartDate && (
              <NavButton
                aria-label="menu"
                onClick={this.startFreeTrialHandler}
                color="inherit"
                style={{
                  color: "#fffd02",
                }}
              >
                <UpdateIcon style={{ marginRight: "10px" }} />
                START FREE TRIAL
              </NavButton>
            )}
            {userType == "FREE_USER" &&
              (daysLeftInTrial <= 0 || !userData?.freeTrialStartDate) && (
                <NavButton
                  aria-label="menu"
                  onClick={this.gotoPlan}
                  color="inherit"
                >
                  <UnarchiveIcon style={{ marginRight: "10px" }} />
                  UPGRADE
                </NavButton>
              )}
            <NavButton
              aria-label="menu"
              onClick={this.gotoProfile}
              color="inherit"
            >
              <AccountBoxIcon style={{ marginRight: "10px" }} />
              PROFILE
            </NavButton>
            <NavButton
              aria-label="menu"
              onClick={this.gotoContact}
              color="inherit"
            >
              <GroupIcon style={{ marginRight: "10px" }} />
              CONTACT
            </NavButton>
            <NavButton
              aria-label="menu"
              onClick={this.gotoTemplate}
              color="inherit"
            >
              <LayersIcon style={{ marginRight: "10px" }} />
              TEMPLATE
            </NavButton>
            {/* <NavButton  aria-label="menu" onClick={this.gotoNarratives}>
                            <MailIcon style={{marginRight:'10px'}}/> RESPONSES 
                        </NavButton> */}
            <NavButton
              aria-label="menu"
              onClick={this.openTutorial}
              color="inherit"
            >
              <HelpIcon style={{ marginRight: "10px" }} /> TUTORIAL VIDEO
            </NavButton>
            <LogoutButton />
          </MobileHideDiv>
        </Toolbar>
      </AppBar>
    );
  }

  renderFileMenu() {
    var file = this._currentOpenFile;

    if (file == null) {
      return;
    }

    return (
      <Menu
        anchorEl={this.anchorEl}
        keepMounted
        open={Boolean(this.anchorEl)}
        onClose={this.handleFileMoreClose}
      >
        <MenuItem onClick={() => this.handleFileNameEdit(file)}>
          <MenuDiv>
            <EditOutlined style={{ marginRight: "10px" }} />
            <Typography fontSize="14px">EDIT WORKFLOW NAME</Typography>
          </MenuDiv>
        </MenuItem>
        <MenuItem onClick={() => this.gotoQuestionnaire(file.fileId)}>
          <MenuDiv>
            <PlayCircleFilledWhiteOutlined style={{ marginRight: "10px" }} />
            <Typography fontSize="14px">PLAY WORKFLOW</Typography>
          </MenuDiv>
        </MenuItem>
        <MenuItem
          onClick={async () =>
            await this.handleFileDuplicate(file.name, file.fileId)
          }
        >
          <MenuDiv>
            <ContentCopyOutlined style={{ marginRight: "10px" }} />
            <Typography fontSize="14px">DUPLICATE</Typography>
          </MenuDiv>
        </MenuItem>
        <MenuItem onClick={() => this.gotoNarratives(file.fileId)}>
          <MenuDiv>
            <MailOutlineOutlined style={{ marginRight: "10px" }} />
            <Typography fontSize="14px"> RESPONSES </Typography>
          </MenuDiv>
        </MenuItem>
        {!file.defaultFile ? (
          <MenuItem
            onClick={() => this.handleDeleteFile(file)}
            disabled={this._deletingFile != null}
          >
            {this._deletingFile == file.fileId ? (
              <CircularProgress size={18} />
            ) : (
              <MenuDiv>
                <DeleteOutlineOutlined
                  style={{ marginRight: "10px", color: "red" }}
                />
                <Typography fontSize="14px" color="red">
                  DELETE WORKFLOW
                </Typography>
              </MenuDiv>
            )}
          </MenuItem>
        ) : null}
      </Menu>
    );
  }

  renderFiles() {
    var { files } = this.props.files;

    var currentFiles = files.filter(
      (file) => file.clinic == this.props.account.currentClinic
    );

    return (
      <List component="nav" aria-label="main mailbox folders" key="files-files">
        {currentFiles.map((file, index) => (
          <React.Fragment key={`file-item-${file.fileId}`}>
            <ListItem button onClick={() => this.gotoFile(file.fileId)}>
              <ListItemIcon>
                <PictureIcon />
              </ListItemIcon>
              <ListItemText primary={file.name} />

              <ListItemSecondaryAction>
                <IconButton
                  aria-label="more"
                  aria-controls="long-menu"
                  aria-haspopup="true"
                  onClick={(e) => this.handleFileMoreClick(e, file)}
                >
                  <MoreVertIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
            {index == currentFiles.length - 1 ? null : <Divider />}
          </React.Fragment>
        ))}

        {this.renderFileMenu()}
      </List>
    );
  }

  renderLoading() {
    return (
      <Grid container justifyContent="center" spacing={4} key="files-loading">
        <Grid item>
          <CircularProgress />
        </Grid>
      </Grid>
    );
  }

  renderEmpty() {
    return (
      <Grid container justifyContent="center" key="files-empty">
        <Grid item>
          <Button onClick={this.addFile} style={{ margin: "24px" }}>
            <Typography style={{ textTransform: "none" }}>
              There are no flows to show. Click to create flow.
            </Typography>
          </Button>
        </Grid>
      </Grid>
    );
  }

  renderContents() {
    var { files } = this.props;

    var currentFiles = files.files.filter(
      (file) => file.clinic == this.props.account.currentClinic
    );

    if (this._status == "LOADING") {
      return this.renderLoading();
    }

    if (currentFiles.length == 0) {
      return this.renderEmpty();
    }

    return this.renderFiles();
  }

  renderSnackbar() {
    return (
      <Snackbar
        open={this._showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          this._showSnackbar = false;
          this._status = "NORMAL";
        }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <div>
          {this._snackbarMessage && (
            <Alert severity={this._snackbarType} variant="filled">
              {this._snackbarMessage}
            </Alert>
          )}
        </div>
      </Snackbar>
    );
  }

  async savePhoneNumber(phone: string) {
    const interPhoneNumber = `+${phone}`;
    try {
      // this._status = 'PHONE_LOADING';
      const userId = firebase.auth().currentUser.uid;
      const userData = await firebase
        .firestore()
        .collection("userx")
        .doc(userId)
        .set(
          {
            phoneNumber: interPhoneNumber,
          },
          { merge: true }
        );
      this._status = "NORMAL";
      this._showSnackbar = true;
      this._snackbarMessage = "Phone number saved Successfully";
      this._snackbarType = "success";
    } catch (err) {
      const { message } = err;

      this._showSnackbar = true;
      this._snackbarMessage = "Something went wrong, try again later";
      this._snackbarType = "error";
      this._status = "NORMAL";
    }
  }

  renderHTMLChat() {
    const userId = firebase.auth().currentUser?.uid;
    return `<div
    class="container"
    style="
      width: fit-content;
      position: fixed;
      width: 300px;
      display: flex;
      flex-direction: column;
      z-index:100000;
      bottom: 20px; right: 30px; align-items: flex-end;flex-direction: column
    "
  >
    <iframe
    id="box"
    src=https://app.flowcharts.ai/web_to_sms/${userId}
    width="300"
    height="650"
    name="box"
    style="display: none; border-radius: 8px; border: none; z-index:100000;"
  ></iframe>
    <div
      id="btn"fix chatbot mobile
      onclick="handleToggle()"
      style="
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background-color: #0a65ff;
        margin: 10px;
        cursor: pointer;
        z-index:100000;
      "
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="#FFFFFF"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M15 4v7H5.17l-.59.59-.58.58V4h11m1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z"
        />
      </svg>
    </div>
  </div>
  <script>
  window.onload = getData;
  const iframe = document.getElementById("box");
  const btn = document.getElementById("btn");
  function handleToggle() {
    iframe.style.display === "none"
      ? (iframe.style.display = "block")
      : (iframe.style.display = "none");
  }

  function getData() {
    var eventMethod = window.addEventListener
      ? "addEventListener"
      : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
    eventer(messageEvent, (e) => {
      const { complete } = e.data;
      if (complete) {
        iframe.style.display = "none";
        btn.style.display = "none";
      }
    });
  }
  </script>
  `;
  }

  renderTutorialDialog() {
    return (
      <Dialog
        open={this._tutorialVideoOpen}
        onClose={() => {
          this._tutorialVideoOpen = false;
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Watch Tutorial Video</DialogTitle>
        <DialogContent style={{ position: "relative" }}>
          <Box width="100%" height="100%" maxWidth="854px" maxHeight="480px">
            <ReactPlayer
              url="http://www.youtube.com/watch?v=QuO-0t3p0Y4"
              controls={true}
              width="854px"
              height="480px"
              style={{
                maxWidth: "854px",
                maxHeight: "480px",
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => (this._tutorialVideoOpen = false)}
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderDirectChat() {
    return (
      <WorkflowsContainer>
        <TitlePaper elevation={0}>
          WebChat Text Messaging Widget
          <CustomTooltip
            title="Put your phone number here and embed this code on your website. Then when a website visitor initiates a conversation, that discussion is converted into a text thread that can carry on even after they navigate away from your site"
            placement="bottom-start"
            arrow
          >
            <HelpIcon
              style={{
                color: "#007bff",
              }}
            />
          </CustomTooltip>
        </TitlePaper>
        <Paper sx={{ marginTop: "1rem", marginBottom: "2rem" }}>
          <Box
            padding="1rem"
            display="flex"
            alignItems="center"
            columnGap="5px"
          >
            <Typography fontSize="1.1rem" fontWeight="600">
              Step 1:
            </Typography>
            <Typography>Enter your phone</Typography>
          </Box>
          <Box
            paddingLeft="1.5rem"
            display="flex"
            alignItems="center"
            columnGap="1rem"
          >
            <PhoneInput
              country={"us"}
              value={this.phoneNumber}
              onChange={(val) => (this.phoneNumber = val)}
              containerStyle={{
                width: "300px",
              }}
              inputStyle={{
                fontSize: "0.8rem",
                width: "100%",
                height: "44px",
              }}
              dropdownStyle={{ zIndex: "10000000" }}
              placeholder="234 456788"
            />

            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => this.savePhoneNumber(this.phoneNumber)}
            >
              Save
            </Button>
          </Box>
          <Box
            padding="1rem"
            display="flex"
            alignItems="center"
            columnGap="5px"
            marginTop="2rem"
          >
            <Typography fontSize="1.1rem" fontWeight="600">
              Step 2:
            </Typography>
            <Typography>HTML code to embedded on your website </Typography>
          </Box>
          <Box
            paddingLeft="1.5rem"
            paddingBottom="2rem"
            display="flex"
            alignItems="center"
            columnGap="1rem"
            width="90%"
          >
            <Input as="textarea" rows={7} value={this.renderHTMLChat()} />
          </Box>
        </Paper>
      </WorkflowsContainer>
    );
  }

  render() {
    // this.props.account.updateClinicData();
    var userType = this.props.account.userData.userType;
    return (
      <React.Fragment>
        <div
          style={{
            width: "100%",
            height: "env(safe-area-inset-top)",
            backgroundColor: "#3f51b5",
          }}
        />
        {this.renderNavBar()}

        <WorkflowsContainer maxWidth="lg">
          <TitlePaper elevation={0}>
            My Flowchart Questionnaire Workflows
            <CustomTooltip
              title="Set up your own FlowChart Workflow that can be deployed and accessed via text message, email, link, embedded on your website, or via a website chat bot"
              placement="bottom-start"
              arrow
            >
              <HelpIcon
                style={{
                  color: "#007bff",
                }}
              />
            </CustomTooltip>
          </TitlePaper>
          <Paper sx={{ marginTop: "1rem", marginBottom: "3rem" }}>
            {this.renderContents()}
          </Paper>
        </WorkflowsContainer>
        <Tooltip title="Add new workflow" placement="left-start">
          <Fab
            variant="extended"
            color="primary"
            aria-label="add"
            onClick={this.addFile}
            style={{
              margin: 0,
              right: 30,
              bottom: 30,
              position: "fixed",
            }}
          >
            <AddIcon /> CREATE NEW FLOWCHART
          </Fab>
        </Tooltip>

        <NewFileDialog dialogState={this._fileDialogState} />
        <NewClinicDialog dialogState={this._clinicDialogState} />
        <UpgradePlanDialog
          upgradeOpen={this._upgradeDialogState}
          upgradeContent={
            "To create more workflows, flowcharts, questionnaires, dynamic surveys, receive more than 5 responses, or use at more locations, UPGRADE NOW!"
          }
        ></UpgradePlanDialog>

        <Dialog
          open={this._deleteDialog}
          onClose={this.handleDeleteDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{`Delete ${this._fileToDelete?.name} ?`}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete the workflow -{" "}
              {this._fileToDelete?.name} ?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => this.handleDeleteDialogClose(false)}
              color="primary"
            >
              NO
            </Button>
            <Button
              onClick={() => this.handleDeleteDialogClose(true)}
              color="primary"
              autoFocus
            >
              YES
            </Button>
          </DialogActions>
        </Dialog>
        {this._isFileNameEdit ? (
          <Dialog
            open={this._isFileNameEdit}
            onClose={() => {
              this._isFileNameEdit = false;
            }}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Edit Flow Name</DialogTitle>
            <DialogContent>
              <DialogContentText>{this._editFile.name}</DialogContentText>
              <TextField
                id="standard-basic"
                label="Flow Name"
                value={this._selectedFileName}
                onChange={(e) => (this._selectedFileName = e.target.value)}
                fullWidth
              ></TextField>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => (this._isFileNameEdit = false)}
                color="primary"
              >
                Cancel
              </Button>
              <Button onClick={this.saveFileNameChange} color="primary">
                Save Flow Name
              </Button>
            </DialogActions>
          </Dialog>
        ) : null}
        {/* <Snackbar
          open={this._snackbarMessage ? true : false}
          autoHideDuration={6000}
          onClose={() => (this._snackbarMessage = null)}
        >
          <div
            style={{
              backgroundColor: 'orange',
              color: 'white',
              padding: '10px',
              borderRadius: '5px',
            }}
          >
            {this._snackbarMessage}
          </div>
        </Snackbar> */}

        {this.renderTutorialDialog()}
        {/* <WorkflowsContainer style={{ paddingBottom: "3rem" }}>
          <SmsSection />
        </WorkflowsContainer> */}
        {userType !== "FREE_USER" && this.renderDirectChat()}
        {this.renderSnackbar()}
      </React.Fragment>
    );
  }
}
